import { Controller } from "@hotwired/stimulus"

// Disabled until the vessel has a successful calculation, and again once its inputs change,
// so only calculated vessels get pushed.
export default class extends Controller {
  static values = { url: String, errorMessage: String, calculated: Boolean, title: String, disabledTitle: String }

  connect() {
    this.form = this.element.closest("form")
    this.editedSinceSubmit = false

    this.boundSubmitted = event => this.submitted(event)
    this.boundRecordCalculation = event => this.recordCalculation(event)
    this.boundMarkStale = event => this.markStale(event)
    this.form?.addEventListener("ajax:send", this.boundSubmitted)
    this.form?.addEventListener("calculation-outcome:recorded", this.boundRecordCalculation)
    this.form?.addEventListener("input", this.boundMarkStale)
  }

  disconnect() {
    this.form?.removeEventListener("ajax:send", this.boundSubmitted)
    this.form?.removeEventListener("calculation-outcome:recorded", this.boundRecordCalculation)
    this.form?.removeEventListener("input", this.boundMarkStale)
  }

  submitted(event) {
    if (event.target === this.form) this.editedSinceSubmit = false
  }

  // An edit made while the calculation is in flight leaves the result out of date as well.
  recordCalculation({ detail }) {
    this.calculatedValue = detail.ok && !this.editedSinceSubmit
  }

  markStale(event) {
    if (!event.target.name?.startsWith("vessel[")) return

    this.editedSinceSubmit = true
    this.calculatedValue = false
  }

  calculatedValueChanged() {
    this.element.classList.toggle("disabled", !this.calculatedValue)
    this.element.setAttribute("aria-disabled", String(!this.calculatedValue))
    this.element.title = this.calculatedValue ? this.titleValue : this.disabledTitleValue
  }

  async push(event) {
    event.preventDefault()
    if (this.element.classList.contains("disabled")) return

    const form = this.form
    if (!form) return

    const trigger = event.currentTarget
    trigger.classList.add("disabled")

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          Accept: "application/json",
        },
        body: new FormData(form),
      })

      const data = await response.json().catch(() => ({}))
      if (!response.ok) {
        this.notify(data.message || this.errorMessageValue)
        return
      }

      this.notify(data.message || this.errorMessageValue)
    } catch (error) {
      console.error("VMS push failed:", error)
      this.notify(this.errorMessageValue)
    } finally {
      trigger.classList.toggle("disabled", !this.calculatedValue)
    }
  }

  notify(message) {
    window.dispatchEvent(new CustomEvent("notify", { detail: { message } }))
  }
}
